<template>
    <!-- 工具栏 -->
    <transition name="fade-right">
        <div class="toolbar" v-show="isShow">
            <el-button v-for="item in toolsList"
                       :icon="`el-icon-${item.icon}`"
                       @click.stop="handleActions(item)"
                       :key="item.val" plain size="mini">{{ item.text }}
            </el-button>
        </div>
    </transition>
</template>

<script>
import { toolsList } from "../config"
import { getParent, uuid } from "@/utils"
const TOP_MESSAGE = "该题已置顶"
const BOTTOM_MESSAGE = "该题已置底"
export default {
    name: "toolbar",
    inheritAttrs: true,
    data() {
        return {
            toolsList,
            isShow: false
        }
    },
    props: {
        index: {
            type: Number,
            default: 0 // 问卷题下标
        }
    },
    methods: {
        open() {
            this.isShow = true
        },
        close() {
            this.isShow = false
        },
        // 处理操作
        handleActions(item) {
            this[`handle${item.val.title()}`](getParent("CreateEmpty", this.$parent))
        },
        // 处理编辑
        handleEdit(parent) {
            parent.currentIndex = this.index
            // 变为全量编辑
            parent.disabledDrag = true
            parent.onMouseleave(parent.questionList[this.index])
        },
        // 处理复制
        handleCopy (parent) {
            const copyValue = JSON.parse(JSON.stringify(parent.questionList[this.index]))
            parent.questionList.splice(this.index + 1, 0, Object.assign(copyValue, {
                no: uuid(6)
            }))
            parent.currentIndex = this.index + 1
            this.$nextTick(() => {
                const view = parent.$refs.questionView
                view[view.length - 1].focus(true, "stem")
            })
        },
        // 处理删除
        handleDel(parent) {
            parent.questionList.splice(this.index, 1)
        },
        // 处理上移
        handleMoveUp(parent) {
            const { questionList } = parent
            if (this.index === 0) {
                return this.$message.warning(TOP_MESSAGE)
            }
            const pre = questionList[this.index - 1]
            const current = questionList[this.index]
            parent.$set(questionList, this.index - 1, current)
            parent.$set(questionList, this.index, pre)
        },
        // 处理下移
        handleMoveDown(parent) {
            const { questionList } = parent
            if (this.index === questionList.length - 1) {
                return this.$message.warning(BOTTOM_MESSAGE)
            }
            const next = questionList[this.index + 1]
            const current = questionList[this.index]
            parent.$set(questionList, this.index + 1, current)
            parent.$set(questionList, this.index, next)
        },
        // 处理置顶
        handleMoveTop(parent) {
            const { questionList } = parent
            if (this.index === 0) {
                return this.$message.warning(TOP_MESSAGE)
            }
            const current = questionList[this.index]
            const first = questionList[0]
            parent.questionList.unshift(current)
            parent.questionList.splice(this.index + 1, 1)
        },
        // 处理置底
        handleMoveBottom(parent) {
            const { questionList } = parent
            if (this.index === questionList.length - 1) {
                return this.$message.warning(BOTTOM_MESSAGE)
            }
            const current = questionList[this.index]
            const end = questionList[questionList.length - 1]
            parent.questionList.push(current)
            parent.questionList.splice(this.index, 1)
        }
    }
}
</script>

<style scoped>
.toolbar {
    position: absolute;
    bottom: 10px;
    right: 0;
}

</style>
